import { type ICellRendererParams } from '@ag-grid-community/core';
import { type ReactNode } from 'react';
import { StatusIcon } from '@pages/notification-components/components/StatusIcon/StatusIcon';
import { type ComponentCreateRequestMapped } from '@pages/notification-components/models/ComponentCreateRequestMapped';

export function StatusCell(
    params: ICellRendererParams<ComponentCreateRequestMapped>,
): ReactNode {
    if (!params.data) {
        return '-';
    }
    const { id, statusCode } = params.data;

    return <StatusIcon id={id} status={statusCode} />;
}
